import { createAsyncThunk } from '@reduxjs/toolkit';
import { API } from 'api/Api';
import { API_URL } from 'api/ApiUrl';
import { errorHandler, successHandler } from 'utils/errorHandler';
import { PANEL_VALUES, isGLG } from 'utils/panel.util';

export const getAssetsLiveData = createAsyncThunk(
    'getAssetsLiveData',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.post(
                API_URL.getAssetsLiveData,
                data.params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 3,
                },
            );
            return {
                data: response,
                panelId: data.panelId,
            };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getNoExecutedData = createAsyncThunk(
    'getNoExecutedData',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.pendingExecutedData}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getNoConfirmedData = createAsyncThunk(
    'getNoConfirmedData',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.pendingConfirmedData}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getUsersUnitCount = createAsyncThunk(
    'getUsersUnitCount',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.getUserUnitCount}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getNoConfirmedCount = createAsyncThunk(
    'getNoConfirmedCount',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.pendingConfirmed}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getNoExecutedCount = createAsyncThunk(
    'getNoExecutedCount',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.pendingExecuted}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getPriceCountsByID = createAsyncThunk(
    'getPriceCountsByID',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.getPriceCountByID}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getExecutedCountsByID = createAsyncThunk(
    'getExecutedCountsByID',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.getExecutedCountByID}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getPriceReqRaisedDataByID = createAsyncThunk(
    'getPriceReqRaisedDataByID',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.getPriceReqRaisedByID}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getExecutedDatasByID = createAsyncThunk(
    'getExecutedDatasByID',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.getExecutedDataByID}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const executedAllRequest = createAsyncThunk(
    'executedAllRequest',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.executedAllRequests}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getGroupInfo = createAsyncThunk(
    'getGroupInfo',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.groupInfo}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getAssetsCount = createAsyncThunk(
    'getAssetsCount',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getAssetCount}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getConfirmedReq = createAsyncThunk(
    'getConfirmedReq',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.confirmedData}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getGroupsCount = createAsyncThunk(
    'getGroupsCount',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getGroupCount}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getUsersCount = createAsyncThunk(
    'getUsersCount',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getUserCount}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getPricesCount = createAsyncThunk(
    'getPricesCount',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getPriceCount}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getExecutedCounts = createAsyncThunk(
    'getExecutedCounts',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getExecutedCount}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getRoles = createAsyncThunk(
    'getRoles',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getRole}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getExecutedLogss = createAsyncThunk(
    'getExecutedLogss',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getExecutedLogs}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const executedAllRequestByID = createAsyncThunk(
    'executedAllRequestByID',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.executedAllRequestsByID}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getAllAssets = createAsyncThunk(
    'getAllAssets',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(`${API_URL.assets}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getAllGroups = createAsyncThunk(
    'getAllGroups',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getAllGroups}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getAllPriceRequests = createAsyncThunk(
    'getAllPriceRequests',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getAllPrice}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const saveGroupsAssets = createAsyncThunk(
    'saveGroupsAssets',
    async (params, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.saveGroup}?email=${email}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getAllGroups(response));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const priceByPage = createAsyncThunk(
    'priceByPage',
    async (params, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.requestsByPage}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const searchGroupName = createAsyncThunk(
    'searchGroupName',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(`${API_URL.getGroupByName}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            successHandler(dispatch, response.message);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const saveUser = createAsyncThunk(
    'saveUser',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        const { params, params1 } = data;
        try {
            const response = await API.post(
                `${API_URL.addUser}?email=${email}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getUserDetail(params1.apptypes));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getLogsByID = createAsyncThunk(
    'getLogsByID',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(
                `${API_URL.getPriceLogsByID}/${id.price_request_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getRequestByGroupIds = createAsyncThunk(
    'getRequestByGroupIds',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;

        try {
            const response = await API.get(
                `${API_URL.getRequestByGroupId}/${id.group_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
            // }
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getYesRequestByGroupIds = createAsyncThunk(
    'getYesRequestByGroupIds',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(
                `${API_URL.getYesRequestByGroupId}/${id.group_id}`,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );

            successHandler(dispatch, response.response);

            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const savPriceReqest = createAsyncThunk(
    'savPriceReqest',
    async (params, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;

        try {
            const response = await API.post(
                `${API_URL.savePrice}?email=${email}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getRequestByGroupIds(params));
            dispatch(priceByPage(params));
            successHandler(dispatch, response.response);

            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getUserDetail = createAsyncThunk(
    'getUserDetail',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;

        try {
            const response = await API.get(`${API_URL.userByAppType}/${data}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getExecutersData = createAsyncThunk(
    'getExecutersData',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.executersData}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const getApcmGroup = createAsyncThunk(
    'getApcmGroup',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(
                `${API_URL.getGroupsById}/${id.id}`,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );

            successHandler(dispatch, response.response);

            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getApcmUserId = createAsyncThunk(
    'getApcmUserId',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.addUser}/${id.id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });

            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getRequestID = createAsyncThunk(
    'getRequestID',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.savePrice}/${id._id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                baseIndex: 0,
            });

            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const deleteGroup = createAsyncThunk(
    'deleteGroup',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.delete(
                `${API_URL.getGroupsById}/${id._id}?email=${email}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getAllGroups(response));

            successHandler(dispatch, response.response);
            return { id };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const deleteUser = createAsyncThunk(
    'deleteUser',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        const { params, params1 } = data;
        try {
            const response = await API.delete(
                `${API_URL.addUser}/${params._id}?email=${email}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getUserDetail(params1.apptypes));
            successHandler(dispatch, response.response);
            return { params };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const deletePriceRequest = createAsyncThunk(
    'deletePriceRequest',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.delete(
                `${API_URL.savePrice}/${id._id}?email=${email}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getRequestByGroupIds(id));
            dispatch(priceByPage(id));
            successHandler(dispatch, response.response);
            return { id };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const deleteExecuteRequest = createAsyncThunk(
    'deletePriceRequest',
    async (id, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.delete(
                `${API_URL.savePrice}/${id._id}?email=${email}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            // dispatch(getRequestID(response));
            successHandler(dispatch, response.response);
            return { id };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const updateGroup = createAsyncThunk(
    'updateGroup',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.put(
                `${API_URL.getGroupsById}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getAllGroups(response));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
export const updateUserPassword = createAsyncThunk(
    'updateUserPassword',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.put(
                `${API_URL.changeUserPassword}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const updateControlPassword = createAsyncThunk(
    'updateControlPassword',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.put(
                `${API_URL.changeControlPassword}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const updateUser = createAsyncThunk(
    'updateUser',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        const { params, params1 } = data;

        try {
            const response = await API.put(
                `${API_URL.addUser}?email=${email}`,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getUserDetail(params1.apptypes));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const updateRequest = createAsyncThunk(
    'updateRequest',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.put(
                `${API_URL.savePrice}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getRequestByGroupIds(data));
            dispatch(priceByPage(data));

            // dispatch(getNoConfirmedData(data));
            successHandler(dispatch, response.response);

            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const updateExecuteRequest = createAsyncThunk(
    'updateExecuteRequest',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.post(
                `${API_URL.executePriceRequest}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getYesRequestByGroupIds(data));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getAllGLGFiles = createAsyncThunk(
    'getAllGLGFiles',
    async (fields, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        try {
            const response = await API.get(`${API_URL.getAllGLGFiles}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const downloadGLG = createAsyncThunk(
    'downloadGLG',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token, email } = session?.auth?.user;
        try {
            const response = await API.post(
                `${API_URL.downloadGLG}?email=${email}`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );

            return {
                value: response,
            };
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getRetryRequests = createAsyncThunk(
    'getRetryRequests',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        const { getId, requestData } = data;
        try {
            const response = await API.post(
                `${API_URL.getRetryRequest}`,
                requestData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getLogsByID(getId));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);

export const getCancelRequests = createAsyncThunk(
    'getCancelRequests',
    async (data, { dispatch, getState }) => {
        const session = getState();
        const { token } = session?.auth?.user;
        const { cancelData, getId } = data;
        try {
            const response = await API.post(
                `${API_URL.getCancelRequest}`,
                cancelData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                    baseIndex: 0,
                },
            );
            dispatch(getLogsByID(getId));
            successHandler(dispatch, response.response);
            return response;
        } catch (error) {
            errorHandler(dispatch, error);
            return Promise.reject({ payload: error });
        }
    },
);
